export function structureAddressParts(googlePlace) {
  let address1 = '';
  let address = {
    latitude: googlePlace.geometry.location.lat(),
    longitude: googlePlace.geometry.location.lng(),
  };

  // Get each component of the address from the place details,
  // and then fill-in the corresponding field on the form.
  // googlePlace.address_components are google.maps.GeocoderAddressComponent objects
  // which are documented at http://goo.gle/3l5i5Mr
  for (const component of googlePlace.address_components) {
    const componentType = component.types[0];

    switch (componentType) {
      case 'street_number': {
        address1 = `${component.long_name} ${address1}`;
        break;
      }

      case 'route': {
        address1 += component.short_name;
        break;
      }

      case 'postal_code': {
        address.zip = component.long_name;
        break;
      }

      case 'locality': {
        address.city = component.long_name;
        break;
      }

      case 'administrative_area_level_1': {
        address.stateAbbreviation = component.short_name;
        break;
      }

      default:
      // no op
    }
  }
  address.streetAddress = address1;

  // Special case for NYC:
  if (address.stateAbbreviation === 'NY' && !address.city) {
    for (const component of googlePlace.address_components) {
      const componentType = component.types[0];

      switch (componentType) {
        case 'neighborhood': {
          address.city = component.long_name;
          break;
        }

        default:
        // no op
      }
    }
  }

  return address;
}
